/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI spec version: 1.0.0
 */

export type PostApiCampaignsBodyMessageType =
    (typeof PostApiCampaignsBodyMessageType)[keyof typeof PostApiCampaignsBodyMessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostApiCampaignsBodyMessageType = {
    EMAIL: 'EMAIL',
    SMS: 'SMS',
} as const;
